export const month = [
	{ id: 1, name: "มกราคม" },
	{ id: 2, name: "กุมภาพันธ์" },
	{ id: 3, name: "มีนาคม" },
	{ id: 4, name: "เมษายน" },
	{ id: 5, name: "พฤษภาคม" },
	{ id: 6, name: "มิถุนายน" },
	{ id: 7, name: "กรกฎาคม" },
	{ id: 8, name: "สิงหาคม" },
	{ id: 9, name: "กันยายน" },
	{ id: 10, name: "ตุลาคม" },
	{ id: 11, name: "พฤศจิกายน" },
	{ id: 12, name: "ธันวาคม" },
];

export const year = () => {
	const d = new Date();
	const n = parseInt(d.getFullYear());
	const newYear = [-1, 0, +1].map((value) => ({ id: n + value, name: `${n + value}` }));
	return newYear;
};

export const betweenDays = [
	{ id: 30, name: "30 วัน" },
	{ id: 60, name: "60 วัน" },
	{ id: 90, name: "90 วัน" },
	{ id: 120, name: "120 วัน" },
];



// WEBPACK FOOTER //
// ./src/constant/Date.js